<script setup lang="ts">
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import { useNotificationStore } from '@/store/notificationStore';
import { zIndex } from '@/theme/zIndex';
import { VisibilityAwareInterval } from '@/utils/visibilityAwareInterval';

const notificationsStore = useNotificationStore();
const toast = useToast();

const polling = new VisibilityAwareInterval(() => {
  const before = notificationsStore.notifications.length;
  notificationsStore
    .loadNotifications()
    .then(() => {
      const after = notificationsStore.notifications.length;
      if (after > before) {
        notifyAboutNewNotification();
      }
    })
    .catch(() => {
      console.log('Notification load failed');
    });
}, 30000);

onMounted(() => {
  notificationsStore.loadNotifications().catch(() => {
    console.log('Notification load failed');
  });
  polling.start();
});

onBeforeUnmount(() => {
  polling.stop();
});

function notifyAboutNewNotification() {
  toast.add({
    severity: 'info',
    summary: $t('notifications.newNotificationPopup'),
    detail: $t('notifications.newNotifications'),
    life: 5000,
  });
}
</script>
<template>
  <Toast position="bottom-center" :base-z-index="zIndex.toast" />
</template>
